let globalObservableLogger;
function getLogger() {
    return globalObservableLogger;
}
export { getLogger };
